import React from 'react';
import { TechnicalCalculator } from '../components/technical';

const TechnicalPage: React.FC = () => {
  return <TechnicalCalculator />;
};

export default TechnicalPage;
